var equalColumnHeightPlugin = require('./../../scripts/equalizeColumnHeights');
var key=require('./../../scripts/UrlParameterHelper');
$(function () {
    //Equalize height of draw game detail promos
    if (!$('.draw-promo-container').length) return;
    $('.equal-height').equalizeColumnHeights();
    console.log(key.getUrlParameterByName('type'));
//if(key.getUrlParameterByName('type'))
});


// WEBPACK FOOTER //
// ./shared/components/draw-promo/draw-promo.js